import { Platform } from "react-native";
import { KeyboardAwareScrollView } from "react-native-keyboard-controller";
import styled from "styled-components/native";
import { colors } from "@/lib/theme";

const FallbackScroll = styled.ScrollView`
  flex: 1;
  background-color: ${colors.bg};
`;

export default function KeyboardAwareScroll({
  children,
  style,
  ...props
}: {
  children: React.ReactNode;
  style?: any;
  [key: string]: any;
}) {
  if (Platform.OS === "web") {
    return (
      <FallbackScroll
        showsVerticalScrollIndicator={false}
        keyboardShouldPersistTaps="handled"
        style={style}
        {...props}
      >
        {children}
      </FallbackScroll>
    );
  }

  return (
    <KeyboardAwareScrollView
      showsVerticalScrollIndicator={false}
      keyboardShouldPersistTaps="handled"
      bottomOffset={20}
      style={[{ flex: 1, backgroundColor: colors.bg }, style]}
      {...props}
    >
      {children}
    </KeyboardAwareScrollView>
  );
}
